import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { motion } from "framer-motion";

const TeacherCard = ({
  teacherList = [],
  batches = [],
  onSubmit,
  setEditData,
  isEdit,
  setIsEdit,
  editData,
}) => {
  const [form, setForm] = useState({
    teacher_id: "",
    batch_ids: [],
  });

  console.log("editData", editData);

  useEffect(() => {
    if (editData) {
      setForm({
        teacher_id: editData.teacher_id,
        batch_ids: editData.batches.map((b) => b.batch_id), // extract batch IDs
      });
    }
  }, [editData]);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleBatchChange = (e) => {
    setForm({
      ...form,
      batch_ids: e.target.value,
    });
    setErrors({ ...errors, batch_ids: "" });
  };

  const handleReset = () => {
    setForm({
      teacher_id: "",
      batch_ids: [],
    });
    setErrors({});
    setEditData(null);
    setIsEdit(false);
  };

  // 🔥 VALIDATION FUNCTION
  const validateForm = () => {
    let temp = {};

    if (!form.teacher_id) {
      temp.teacher_id = "Please select a teacher";
    }

    if (!form.batch_ids || form.batch_ids.length === 0) {
      temp.batch_ids = "Please select at least one batch";
    }

    setErrors(temp);

    return Object.keys(temp).length === 0; // true = valid
  };

  // 🔥 HANDLE SUBMIT (Only child validation, parent submit)
  const handleSubmit = () => {
    console.log("CHILD SUBMIT:", form);

    // Step 1 → Validate first
    if (!validateForm()) {
      console.log("FORM INVALID ❌");
      return;
    }

    // Step 2 → If valid, send data to parent
    if (onSubmit) {
      onSubmit(form);
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{ width: "100%", padding: "16px" }}
      >
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Grid container spacing={2}>
              {/* Teacher Select */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  select
                  label="Select Teacher"
                  name="teacher_id"
                  value={form.teacher_id}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={!!errors.teacher_id}
                >
                  {teacherList.map((t) => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.name}
                    </MenuItem>
                  ))}
                </TextField>
                {errors.teacher_id && (
                  <FormHelperText error>{errors.teacher_id}</FormHelperText>
                )}
              </Grid>

              {/* Batch Multi Select */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  select
                  label="Select Batches"
                  name="batch_ids"
                  value={form.batch_ids}
                  onChange={handleBatchChange}
                  fullWidth
                  size="small"
                  SelectProps={{
                    multiple: true,
                  }}
                  error={!!errors.batch_ids}
                >
                  {batches.map((b) => (
                    <MenuItem key={b.id} value={b.id}>
                      {b.item_name}
                    </MenuItem>
                  ))}
                </TextField>
                {errors.batch_ids && (
                  <FormHelperText error>{errors.batch_ids}</FormHelperText>
                )}
              </Grid>

              {/* Buttons */}
              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="flex-end"
                gap={2}
                mt={2}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleReset}
                >
                  Reset
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {isEdit ? "Update" : "Add"}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </motion.div>
    </>
  );
};

export default TeacherCard;
